import Fetch from 'fetch';

export default {
    getLoginConfig() {
        return Fetch.get('/site-olb/v1/configurations/pre-login?channel=WEB')
            .then((loginConfig) => {
                return {
                    ...loginConfig,
                };
            })
            .catch((e) => console.error('Error fetching login config', e));
    },
};
